webpackJsonp([91982479355956],{

/***/ 1071:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0041_molting_firebird.jpg","type":"Unit","subtype":"Bird","cost":4,"ATK":4,"HP":3,"rules_text_1":"Flying","rules_text_2":"Damages a building: Deal 1 damage to every unit and hero that opponent controls.","rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Molting Firebird","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Red","spec":"Fire","bottom":"Tech II","rulings":[],"keywords":["Flying"],"slug":"molting_firebird"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"molting_firebird","keywords":["Flying"],"imageRegex":"/molting_firebird.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-molting-firebird-283c71af85dda16528c8.js